// components/StudentPortal/Home/StudentHomeVR.js
// Home "Hoy" optimizada para VR (S1-VR, F8). En VR el alumno NO escribe: solo
// VISIONA la sala activa que abre el profesor en el itinerario. Por eso aqui no
// hay tareas ni asistente; unicamente la sala activa (o un aviso si aun no se ha
// abierto). Las escenas se abren en la MISMA pestana (en Quest, una pestana
// nueva saca al alumno del contexto). Reutiliza el mismo hook que la pantalla.
import React from "react";
import { useTranslation } from "react-i18next";
import { useStudentHome } from "./useStudentHome";
import styles from "./StudentHomeVR.module.scss";

export function StudentHomeVR() {
  const { t } = useTranslation("students");
  const { loading, error, student, activeScene, reload, trackSceneOpen } =
    useStudentHome();

  // En VR: misma pestana. La baliza va con keepalive para que sobreviva a la
  // navegacion inmediata.
  const enterScene = () => {
    if (activeScene?.enterUrl) {
      trackSceneOpen();
      window.location.href = activeScene.enterUrl;
    }
  };

  if (loading)
    return <div className={styles.state}>{t("newHome.loading")}</div>;
  if (error === "no-student")
    return <div className={styles.state}>{t("newHome.noStudent")}</div>;
  if (error)
    return (
      <div className={styles.state}>
        {t("newHome.error")}{" "}
        <button type="button" className={styles.linkBtn} onClick={reload}>
          {t("newHome.retry")}
        </button>
      </div>
    );

  return (
    <div className={styles.vrHome}>
      <h1 className={styles.hello}>
        {t("newHome.greeting", { name: student?.name || "" })}
      </h1>
      <p className={styles.sub}>{student?.classnumber || ""}</p>

      {activeScene ? (
        <button type="button" className={styles.heroCard} onClick={enterScene}>
          <span className={`${styles.pill} ${styles.pillGreen}`}>
            {t("newHome.activeScene")}
          </span>
          <span className={styles.heroTitle}>{activeScene.title}</span>
          {activeScene.category ? (
            <span className={styles.heroMeta}>{activeScene.category}</span>
          ) : null}
          <span className={styles.heroCta}>{t("newHome.enterScene")}</span>
        </button>
      ) : (
        <div className={`${styles.heroCard} ${styles.noRoom}`}>
          <span className={styles.vrIcon} aria-hidden="true">
            🥽
          </span>
          <span className={styles.heroTitle}>{t("newHome.vrNoRoomTitle")}</span>
          <span className={styles.heroMeta}>{t("newHome.vrNoRoomText")}</span>
        </div>
      )}
    </div>
  );
}
